import React from "react";
import Layout from "../components/layout";
import Hero from "../components/hero";
import { ReactComponent as CALENDAR } from "../assets/svg/calendar.svg";
import { ReactComponent as REALTIME } from "../assets/svg/notifiysvg.svg";
import { ReactComponent as MAP } from "../assets/svg/map.svg";
const Home = () => {
  return (
    <div>
      <Layout>
        <Hero />
        <div className="border-gray-200 border-b">
          <div className="bg-white px-4 pt-16">
            <h1 className="text-center bold text-2xl py-4">Our Product</h1>
            <div className="text-gray-700 text-center text-lg">
              <h1>
                View all the available events offered by Sac State at your
                fingertips, thanks to Hornet Vision!
              </h1>
            </div>
            <div className="pb-8">
              <CALENDAR className="h-24 w-full self-center mt-12 mb-8" />
            </div>
          </div>
          <div className="bg-gray-100">
            <div className="px-4">
              <h1 className="text-center bold text-2xl pt-16 pb-4">
                Augmented Reality (AR)
              </h1>
              <div className="text-gray-700 text-center text-lg">
                <h1 className="">
                  Ultilizing AR tech stack to guide user’s to their events
                </h1>
                <h1>
                  Track events by their location and be guided to your event's
                  location in AR.
                </h1>
              </div>
              <MAP className="h-64 w-full self-center pt-16 pb-8" />
            </div>
          </div>
          <div className="bg-white pb-8">
            <div className="px-4">
              <h1 className="text-center bold text-2xl pt-16 pb-4">
                Real time update
              </h1>
              <div className="text-gray-700 text-center text-lg">
                <h1>
                  Hornet Vision is constantly updating, so you don't have to
                  worry about your event getting cancelled without you knowing.
                </h1>
              </div>
            </div>
            <REALTIME className="h-64 w-full self-center px-4 pt-16 pb-8" />
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default Home;
